import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.scrollContainer = document.querySelector(".app-main")
        if (!this.scrollContainer) return

        this.boundUpdateState = this.updateState.bind(this)
        this.scrollContainer.addEventListener("scroll", this.boundUpdateState, { passive: true })

        this.resizeObserver = new ResizeObserver(this.boundUpdateState)
        this.resizeObserver.observe(this.scrollContainer)

        const content = this.scrollContainer.querySelector(".app-content")
        if (content) this.resizeObserver.observe(content)

        requestAnimationFrame(this.boundUpdateState)
    }

    disconnect() {
        if (this.scrollContainer && this.boundUpdateState) {
            this.scrollContainer.removeEventListener("scroll", this.boundUpdateState)
        }

        this.resizeObserver?.disconnect()
    }

    updateState() {
        if (!this.scrollContainer) return

        const tolerance = 1
        const container = this.scrollContainer
        const scrollable = container.scrollHeight > container.clientHeight + tolerance
        const scrolledToEnd = !scrollable ||
            container.scrollTop + container.clientHeight >= container.scrollHeight - tolerance

        this.element.classList.toggle("app-footer--elevated", scrollable && !scrolledToEnd)
    }
}
